import { Component, inject, Input, OnInit } from '@angular/core';
import { SbLocalDate, SbLocalDateTime } from 'src/app/services/api/api-date-time';
import { DateTime } from 'luxon';
import { StringTransformationService } from '../../services/transformation-helper/string-transformation.service';
import { TranslateService } from '@ngx-translate/core';
import { DateTransformationService } from '../../services/transformation-helper/date-transformation.service';

@Component({
  selector: 'sb-comp-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss'],
  standalone: false,
})
export class InfoCardComponent implements OnInit {
  private readonly stringTransformation = inject(StringTransformationService);
  private readonly dateTransformation = inject(DateTransformationService);

  @Input() reportingObj;
  @Input() selectedField;
  @Input() from;
  @Input() till;
  // tslint:disable-next-line:variable-name
  _date?: SbLocalDate;
  index: number;
  isMedium: boolean;

  constructor(private readonly translate: TranslateService) {
    this.index = -1;
    this.isMedium = false;
  }

  get date(): SbLocalDate {
    return this._date;
  }

  set date(val) {
    this._date = val;
  }

  ngOnInit(): void {
    if (this.reportingObj) {
      this.index = 0;
    } else {
      this.index = -1;
    }
  }

  setHoverStatus(id: number, status: boolean, isMedium: boolean) {
    if (status) {
      if (id <= this.reportingObj.length) {
        this.index = id;
        this.isMedium = isMedium;
      }
    }
  }

  fillPlayoutsForDate(): string {
    if (this.date) {
      if (this.index !== -1) {
        const rep = this.reportingObj[this.index];
        for (const date of rep.report.byDate) {
          const dateObj = DateTime.fromISO(date.r0);
          const d = DateTime.fromISO(this.date.toString());
          if (dateObj.valueOf() === d.valueOf()) {
            return date.v0 > 0 ? this.stringTransformation.transformNumber(date.v0) : this.translate.instant('lang.globals.selectDate');
          }
        }
      }
    }
    return this.translate.instant('lang.globals.selectDate');
  }

  fillPlayoutTimeForDate(): string {
    if (this.date) {
      if (this.index !== -1) {
        const rep = this.reportingObj[this.index];
        for (const date of rep.report.byDate) {
          const dateObj = DateTime.fromISO(date.r0);
          const d = DateTime.fromISO(this.date.toString());
          if (dateObj.valueOf() === d.valueOf()) {
            if (date.v0 === 0) {
              return this.translate.instant('lang.globals.selectDate');
            }
            return this.dateTransformation.parseTimeToDuration(date.v1);
          }
        }
      }
    }
    return this.translate.instant('lang.globals.selectDate');
  }

  fillMostPlayedForDate(): string {
    if (!this.date || this.index === -1) {
      return this.translate.instant('lang.globals.selectDate');
    }
    const rep = this.reportingObj[this.index];
    for (const date of rep.report.byDate) {
      const dateObj = DateTime.fromISO(date.r0);
      const d = DateTime.fromISO(this.date.toString());
      if (dateObj.valueOf() === d.valueOf()) {
        const hourArray = new Array<number>(24).fill(0);
        for (let hour = 0; hour < rep.report.byHour.length; hour++) {
          if (dateObj.valueOf() === DateTime.fromISO(rep.report.byHour[hour].r0).valueOf()) {
            hourArray[hour % 24] += rep.report.byHour[hour].v0;
          }
        }
        if (date.v0 === 0) {
          return this.translate.instant('lang.globals.selectDate');
        }
        return this.getTimeslotString(hourArray.indexOf(Math.max(...hourArray)));
      }
    }
  }

  fillPlayouts(): string {
    if (this.index !== -1) {
      const rep = this.reportingObj[this.index];
      return this.stringTransformation.transformNumber(rep.report.aggregated.v0);
    }
    return 'XXXX';
  }

  fillPlayoutTime(): string {
    if (this.index !== -1) {
      const rep = this.reportingObj[this.index];
      return this.dateTransformation.parseTimeToDuration(rep.report.aggregated.v1);
    }
    return 'YYdXXhXXmXXs';
  }

  /*
                                      fillScreens(): string {
                                        if (this.index !== -1) {
                                          const rep = this.reportingObj[this.index];
                                          return this.util.transformNumber(rep.report.aggregated.v5);
                                        }
                                        return 'XXXX';
                                      }
                                    */

  fillMostPlayed(): string {
    if (this.index !== -1) {
      const rep = this.reportingObj[this.index];
      return this.findMostPlayedHour(rep);
    }
    return 'XX:XX - YY:YY';
  }

  findMostPlayedHour(report: any): string {
    const hourArray = new Array<number>(24).fill(0);
    for (let hour = 0; hour < report.report.byTimeslot.length; hour++) {
      hourArray[hour] += report.report.byTimeslot[hour].v0;
    }
    return this.getTimeslotString(hourArray.indexOf(Math.max(...hourArray)));
  }

  getTimeslotString(timeslot: number): string {
    if (timeslot + 1 === 24) {
      return '23:00 - 00:00';
    }
    return (
      '' +
      this.dateTransformation.doubleDigitDisplay(timeslot) +
      ':00 - ' +
      this.dateTransformation.doubleDigitDisplay(timeslot + 1) +
      ':00'
    );
  }

  handleDateChange(date: SbLocalDateTime) {
    this.date = new SbLocalDate(date.value);
  }

  enabledDates(): SbLocalDate[] {
    const dates: SbLocalDate[] = [];
    if (this.index !== -1) {
      const reportingDates = this.reportingObj[this.index].report.byDate;
      for (const reportingDate of reportingDates) {
        if (reportingDate.v0 > 0) {
          const singleDate = new SbLocalDate(DateTime.fromISO(reportingDate.r0));
          dates.push(singleDate);
        }
      }
    }
    return dates;
  }
}
